import styled, { injectGlobal } from 'styled-components';
import { Modal as modal } from 'reactstrap';

export const Modal = styled(modal)`
  text-align: center;

  .modal-content {
    background-color: transparent;
    border: none;
    p {
      font-size: 18px;
      font-weight: bold;
      text-transform: uppercase;
      margin-top: -60px;
    }
  }
`;

injectGlobal`
  .super-modal{
    background-color: #fff !important;
    &.modal-backdrop.show{
      opacity: 0.7;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/SuperLoading/style.js